// Microsoft Defender for Endpoint datasource mappings.
// Uses repo field to carry the KQL table name for each category.
// Table names are standard Defender Advanced Hunting tables.
// Users can override via DataSourceDirective.repo to target a non-default table.
import type { DatasourceMap } from '../datasource.types'

export const defenderMap: DatasourceMap = {
  'Microsoft Defender': {
    any: {
      process_creation: { repo: 'DeviceProcessEvents' },
      file_event: { repo: 'DeviceFileEvents' },
      network_connection: { repo: 'DeviceNetworkEvents' }, 
      registry_event: { repo: 'DeviceRegistryEvents' },
      authentication_events: { repo: 'DeviceLogonEvents' },
      image_load: { repo: 'DeviceImageLoadEvents' },
      // Cloud app/O365 activity visible in CloudAppEvents (MSFT-centric; not multi-cloud)
      cloud: { repo: 'CloudAppEvents' },
      // DNS queries captured in network events 
      dns: { repo: 'DeviceNetworkEvents', events: [ 'DnsConnectionInspected' ], unsupportedFields: [ 'dns_answer' ] },
      // RDP logons visible in DeviceLogonEvents; user can filter on LogonType = RemoteInteractive
      //Rdp_event: { repo: 'DeviceLogonEvents' },
      // Named pipe events visible in DeviceEvents via ActionType = NamedPipeEvent
      pipe_created: { repo: 'DeviceEvents', events: [ 'NamedPipeEvent' ] },
    },
  },
}
